import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Header from './components/Header';
import Footer from './components/Footer';
import HomeScreen from './screens/HomeScreen';
import LoginScreen from './screens/LoginScreen';
import PlayersScreen from './screens/PlayersScreen';
import CommercialsScreen from './screens/CommercialsScreen';
import ProgrammesScreen from './screens/ProgrammesScreen';
import CampaignsScreen from './screens/CampaignsScreen';
import SignalsScreen from './screens/SignalsScreen';
import AnnouncementsScreen from './screens/AnnouncementsScreen';
import RegisterScreen from './screens/RegisterScreen';
import PlayerScreen from './screens/PlayerScreen';
import CommercialScreen from './screens/CommercialScreen';
import ProgrammeScreen from './screens/ProgrammeScreen';
import CampaignScreen from './screens/CampaignScreen';
import SignalScreen from './screens/SignalScreen';
import AnnouncementScreen from './screens/AnnouncementScreen';
import AnnouncementRegisterScreen from './screens/AnnouncementRegisterScreen';
import AdminScreen from './screens/AdminScreen';
import ProfileScreen from './screens/ProfileScreen';
import NotFoundScreen from './screens/NotFoundScreen';
import PlayerRegisterScreen from './screens/PlayerRegisterScreen';
import CommercialRegisterScreen from './screens/CommercialRegisterScreen';
import SignalRegisterScreen from './screens/SignalRegisterScreeen';
import CampaignRegisterScreen from "./screens/CampaignRegisterScreen";
import SettingsScreen from "./screens/SettingsScreen";
import DownloadsScreen from "./screens/DownloadsScreen";
import useTranslation from "./hooks/useTranslation";
import ResourcesScreen from "./screens/ResourcesScreen";
import VideosScreen from "./screens/VideosScreen";
import VideoRegisterScreen from "./screens/VideoRegisterScreen";
import VideoScreen from "./screens/VideoScreen";
import VideoCampaignScreen from "./screens/VideoCampaignScreen";
import VideoCampaignRegisterScreen from "./screens/VideoCampaignRegisterScreen";
import VideoCampaignsScreen from "./screens/VideoCampaignsScreen";
import VideoPlayerScreen from "./screens/VideoPlayerScreen";
import VideoPlayersScreen from "./screens/VideoPlayersScreen";
import VideoPlayerRegisterScreen from "./screens/VideoPlayerRegisterScreen";
import AdminActivitiesScreen from "./screens/AdminActivitiesScreen";
import VideoProgrammesScreen from "./screens/VideoProgrammesScreen";
import AdminVideoLogsScreen from "./screens/AdminVideoLogsScreen";
import AdminPretendChangeScreen from "./screens/AdminPretendChangeScreen";
import AdminDeleteUserScreen from "./screens/AdminDeleteUserScreen";

function App() {
    const {language, setLanguage, fallbackLanguage, setFallbackLanguage,t} = useTranslation();

    return (
        <Router>
            <Header language={language} setLanguage={setLanguage} t={t}/>
            <main className='py-4'>
                <Container>
                    <Switch>
                        <Route path='/login' render={(props) => <LoginScreen language={language} t={t} {...props}/>} />
                        <Route path='/register' render={(props) => <RegisterScreen language={language} t={t} {...props}/>} />
                        <Route path='/admin' render={(props) => <AdminScreen language={language} t={t} {...props}/>} exact/>
                        <Route path='/admin_video' render={(props) => <AdminVideoLogsScreen language={language} t={t} {...props}/>} exact/>
                        <Route path='/admin_change' render={(props) => <AdminPretendChangeScreen language={language} t={t} {...props}/>} exact/>
                        <Route path='/admin_delete_user' render={(props) => <AdminDeleteUserScreen language={language} t={t} {...props}/>} exact/>
                        <Route path='/admin_activities' render={(props) => <AdminActivitiesScreen language={language} t={t} {...props}/>} exact/>
                        <Route path='/profile' render={(props) => <ProfileScreen language={language} t={t} {...props}/>} />
                        <Route
                            path='/players'
                            render={(props) => <PlayersScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/players/create'
                            render={(props) => <PlayerRegisterScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route path='/players/:id' render={(props) => <PlayerScreen language={language} t={t} {...props}/>} />
                        <Route
                            path='/video_players'
                            render={(props) => <VideoPlayersScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/video_players/create'
                            render={(props) => <VideoPlayerRegisterScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route path='/video_players/:id' render={(props) => <VideoPlayerScreen language={language} t={t} {...props}/>} />
                        <Route
                            path='/signals'
                            render={(props) => <SignalsScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/signals/create'
                            render={(props) => <SignalRegisterScreen language={language} t={t} {...props}/>}
                        />
                        <Route path='/signals/:id' render={(props) => <SignalScreen language={language} t={t} {...props}/>} />
                        <Route
                            path='/commercials'
                            render={(props) => <CommercialsScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/commercials/create'
                            render={(props) => <CommercialRegisterScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/commercials/:id'
                            render={(props) => <CommercialScreen language={language} t={t} {...props}/>}
                        />
                        <Route
                            path='/programmes'
                            render={(props) => <ProgrammesScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/video_programmes'
                            render={(props) => <VideoProgrammesScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/programmes/:id'
                            render={(props) => <ProgrammeScreen language={language} t={t} {...props}/>}
                        />
                        <Route
                            path='/campaigns'
                            render={(props) => <CampaignsScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/campaigns/create'
                            render={(props) => <CampaignRegisterScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/campaigns/:id'
                            render={(props) => <CampaignScreen language={language} t={t} {...props}/>}
                        />
                        <Route
                            path='/video_campaigns'
                            render={(props) => <VideoCampaignsScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/video_campaigns/create'
                            render={(props) => <VideoCampaignRegisterScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/video_campaigns/:id'
                            render={(props) => <VideoCampaignScreen language={language} t={t} {...props}/>}
                        />
                        <Route
                            path='/announcements'
                            render={(props) => <AnnouncementsScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/announcements/create'
                            render={(props) => <AnnouncementRegisterScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/announcements/:id'
                            render={(props) => <AnnouncementScreen language={language} t={t} {...props}/>}
                        />
                        <Route
                            path='/videos'
                            render={(props) => <VideosScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/videos/create'
                            render={(props) => <VideoRegisterScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                            path='/videos/:id'
                            render={(props) => <VideoScreen language={language} t={t} {...props}/>}
                        />
                        <Route
                            path='/settings/:id'
                            render={(props) => <SettingsScreen language={language} t={t} {...props}/>}
                        />
                        <Route
                            path='/downloads'
                            render={(props) => <DownloadsScreen language={language} t={t} {...props}/>}
                            exact
                        />
                        <Route
                        path='/resources'
                        render={(props) => <ResourcesScreen language={language} t={t} {...props}/>}
                        exact
                        />
                        <Route path='/home' component={() => {window.location.replace('http://augmentit.hu/smadify/'); return null;}}/>
                        <Route path='/' component={() => {window.location.replace('http://augmentit.hu/smadify/'); return null;}} exact />
                        <Route render={(props) => <NotFoundScreen language={language} t={t} {...props}/>} />
                    </Switch>
                </Container>
            </main>
            <Footer />
        </Router>
    );
}

export default App;
